import apiClient from "lib/axios";

export interface ContactPayload {
  name: string;
  email: string;
  phone?: string;
  service?: string;
  subject: string;
  message: string;
}

export const contactService = {
  send: async (payload: ContactPayload): Promise<void> => {
    await apiClient.post("/contact", payload);
  },
};
